__turbopack_context__.v({
  "Backdrop": "Modal-module-sass-module__pEsZFW__Backdrop",
  "Close": "Modal-module-sass-module__pEsZFW__Close",
  "FadeOut": "Modal-module-sass-module__pEsZFW__FadeOut",
  "Modal": "Modal-module-sass-module__pEsZFW__Modal",
  "ModalContainer": "Modal-module-sass-module__pEsZFW__ModalContainer",
  "ModalMain": "Modal-module-sass-module__pEsZFW__ModalMain",
  "NoBackground": "Modal-module-sass-module__pEsZFW__NoBackground",
  "Show": "Modal-module-sass-module__pEsZFW__Show",
});
